import { t } from 'i18next';
import Select, { StylesConfig, SingleValue } from 'react-select';

export interface OptionItem {
  key: string | number;
  label: string;
  new?: boolean;
  [key: string]: any;
}

interface SmartSelectProps {
  options: OptionItem[];
  label?: string;
  value?: SingleValue<OptionItem> | null | undefined;
  onChangeSelected: (selected: OptionItem | null) => void;
  disabled?: boolean;
  placeholder?: string;
  styles?: React.CSSProperties;
  className?: string;
  isLoading?: boolean;
}

export const customStylesReactSelect: StylesConfig<OptionItem, false> = {
  control: (provided) => ({
    ...provided,
    minHeight: 36,
    borderColor: 'rgb(96, 94, 92)',
    ':focus-within': {
      borderColor: 'rgb(0, 120, 212)',
      boxShadow: '0 0 0 1px rgb(0, 120, 212)',
    },
  }),
  menu: (provided) => ({ ...provided, zIndex: 1000 }),
  option: (base, { isSelected, isFocused }) => ({
    ...base,
    ':hover': {
      background: 'rgb(243, 242, 241)',
      color: 'rgb(32, 31, 30)',
    },
    background: isSelected && isFocused ? 'rgb(243, 242, 241)' : '#ffffff',
    color: isSelected && isFocused ? 'rgb(32, 31, 30)' : '#000',
  }),
};

const SmartSelect: React.FC<SmartSelectProps> = ({
  options,
  label,
  value,
  onChangeSelected,
  disabled = false,
  placeholder = 'Seleccione una opción...',
  styles,
  className,
  isLoading = false,
}) => {
  return (
    <div className={className} style={styles}>
      {label && <label style={{ padding: '5px 0', display: 'block' }}>{label}</label>}
      <Select
        isDisabled={disabled}
        isLoading={isLoading}
        options={options}
        value={value}
        onChange={onChangeSelected}
        placeholder={isLoading ? 'Cargando...' : placeholder}
        noOptionsMessage={() => t('No se encontraron resultados')}
        styles={customStylesReactSelect}
        isClearable
        isSearchable
      />
    </div>
  );
};

export default SmartSelect;
